/**
 * Goal Management types (Epic 1)
 * Aligned with docs/api/goal-management-openapi.yaml
 */

export const PAGES_PER_KHATM = 604; // Madani Mushaf
export const JUZ_PER_KHATM = 30;

export type GoalStatus = 'active' | 'completed' | 'replaced';

/**
 * Epic 4: Dynamic Progress types
 * Aligned with docs/api/epic-4-dynamic-progress-openapi.yaml
 */
export type ProgressStatus = 'behind' | 'on_track' | 'ahead' | 'overdue';

export interface GoalProgressData {
  goal_id: string;
  daily_target_pages: number;
  /** เป้าหมายหน้าต่อวันแบบคงที่ (จาก API extended fields) */
  baseline_daily_target_pages?: number;
  daily_target_pages_diff?: number;
  expected_last_page_by_today?: number;
  pages_ahead_or_behind?: number;
  pages_read_total: number;
  pages_read_today: number;
  pages_remaining_today: number;
  pages_remaining_today_baseline?: number;
  sessions_count_today: number;
  days_remaining: number;
  last_read_page: number;
  next_page_to_read: number;
  khatm_completed: number;
  khatm_target: number;
  status: ProgressStatus;
  suggestion_message?: string | null;
}

export interface GoalProgressResponse {
  data: GoalProgressData;
}

export interface Goal {
  id: string;
  user_id: string;
  khatm_count: number;
  start_date: string; // YYYY-MM-DD
  end_date: string;
  timezone?: string;
  status: GoalStatus;
  created_at?: string;
  updated_at?: string;
}

export interface CreateGoalRequest {
  khatm_count: number;
  end_date: string;
  start_date?: string;
  timezone?: string;
}

export interface CreateGoalResponse {
  data: Goal;
  replaced_goal_id?: string | null;
  warnings?: string[];
}

export interface UpdateGoalRequest {
  khatm_count?: number;
  start_date?: string;
  end_date?: string;
  timezone?: string;
}

export interface UpdateGoalResponse {
  data: Goal;
  warnings?: string[];
}

export interface GoalResponse {
  data: Goal;
}

export interface GoalListResponse {
  data: Goal[];
}

/**
 * Goal completion summary (GET /api/goals/:id/summary)
 */
export interface GoalSummaryData {
  goal: Goal;
  total_pages_read: number;
  total_pages_target: number;
  completion_percentage: number;
  total_days_in_goal: number;
  active_days: number;
  missed_days: number;
  active_dates: string[];
  missed_dates: string[];
  max_streak: number;
  current_streak: number;
  daily_pages: Array<{ date: string; pages_read: number }>;
  khatm_completed: number;
  khatm_target: number;
}

export interface GoalSummaryResponse {
  data: GoalSummaryData;
}

export interface ApiError {
  error: {
    code: string;
    message: string;
  };
}

export interface ValidationErrorDetail {
  path: string;
  message: string;
}

export interface ValidationErrorResponse {
  error: {
    code: string;
    message: string;
    details?: ValidationErrorDetail[];
  };
}

export function totalPagesForGoal(khatmCount: number): number {
  return PAGES_PER_KHATM * khatmCount;
}

export function totalJuzForGoal(khatmCount: number): number {
  return JUZ_PER_KHATM * khatmCount;
}
